import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { CHAT_IA_DISPONIVEL } from '../../config/chat-ia';

/**
 * Com a chave desligada (hml e producao) a rota do assistente nao casa: o
 * modulo nem e baixado e a URL cai no '**' do app, como qualquer endereco que
 * nao existe.
 */
export const chatIaDisponivelGuard: CanMatchFn = () =>
  inject(CHAT_IA_DISPONIVEL);
